import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  LOAD_SANTANDER_PAYMENT_REPORTS,
  loadSantanderPaymentReports,
  CLEAR_SANTANDER_CLABE_OPTIONS
} from 'src/store/actions/santanderClabeActions';
import {
  selectSantanderClabeList,
  selectSantanderClabeCount,
  selectSantanderClabeQueryOptions
} from 'src/store/selectors/santanderClabeSelectors';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import SantanderReportsTable from './SantanderReportsTable';

const SantanderReportsList = () => {
  const dispatch = useDispatch();
  const reports = useSelector(selectSantanderClabeList);
  const count = useSelector(selectSantanderClabeCount);
  const success = useSelector(
    successSelector([LOAD_SANTANDER_PAYMENT_REPORTS.action])
  );
  const queryOptions = useSelector(selectSantanderClabeQueryOptions);
  const isLoading = useSelector(
    isLoadingSelector([LOAD_SANTANDER_PAYMENT_REPORTS.action])
  );

  const handleChangePage = useCallback(
    (event, newPage) => {
      dispatch(loadSantanderPaymentReports({ ...queryOptions, page: newPage }));
    },
    [dispatch, queryOptions]
  );

  useEffect(() => {
    const now = momentLocalTimezone();
    const firstDayOfMonth = now.clone().startOf('month').startOf('day');
    const lastDayOfMonth = now.clone().endOf('month').endOf('day');

    const optionsToUse = {
      limit: +process.env.REACT_APP_TABLE_SIZE,
      startDate: firstDayOfMonth.toDate(),
      endDate: lastDayOfMonth.toDate(),
      page: 0
    };

    dispatch(loadSantanderPaymentReports(optionsToUse));
    return () => {
      dispatch({ type: CLEAR_SANTANDER_CLABE_OPTIONS });
    };
  }, [dispatch]);

  return (
    <SantanderReportsTable
      reports={reports}
      count={count}
      page={queryOptions.page}
      handleChangePage={handleChangePage}
      loading={isLoading}
      success={success}
    />
  );
};

export default SantanderReportsList;
